import { render, staticRenderFns } from "./DamageFields.vue?vue&type=template&id=2d9d90de&scoped=true"
import script from "./DamageFields.vue?vue&type=script&lang=ts"
export * from "./DamageFields.vue?vue&type=script&lang=ts"
import style0 from "./DamageFields.vue?vue&type=style&index=0&id=2d9d90de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9d90de",
  null
  
)

export default component.exports